import insideStory from '../images/retention/F1RetentionIcon_InsideStory.jpeg';
import techTalk from '../images/retention/F1RetentionIcon_TechTalk.jpeg';
import vettel from '../images/retention/F1RetentionIcon_Vettel.jpeg';
import beyondAllLimits from '../images/retention/F1RetentionIcon_BeyondAllLimits.jpeg';
import chasingTheDream from '../images/retention/F1RetentionIcon_ChasingTheDream.jpeg';
import analysis from '../images/retention/F1RetentionIcon_Analysis.jpeg';
import bestOnboards from '../images/retention/F1RetentionIcon_BestOnboards.jpeg';

export const additionalImages = () => {
  const images = [
    {
      imageUrl: 'thumbnail-1.png',
      targetUrl: 'https://f1tv.formula1.com/page/1299/tech-talk',
    },
    {
      imageUrl: 'thumbnail-2.png',
      targetUrl: 'https://f1tv.formula1.com/page/1273/weekend-debrief',
    },

    {
      imageUrl: 'thumbnail-3.png',
      targetUrl: 'https://f1tv.formula1.com/page/1789/jolyon-palmer-s-analysis',
    },
    {
      imageUrl: 'thumbnail-4.png',
      targetUrl: 'https://f1tv.formula1.com/page/4972/radio-rewind',
    },
    {
      imageUrl: 'thumbnail-5.png',
      targetUrl: 'https://f1tv.formula1.com/page/2220/best-onboards',
    },
    {
      imageUrl: 'thumbnail-6.png',
      targetUrl: 'https://f1tv.formula1.com/page/1724/inside-story',
    },
    {
      imageUrl: 'thumbnail-7.png',
      targetUrl: 'https://f1tv.formula1.com/page/5360/top-10',
    },
    {
      imageUrl: 'thumbnail-8.png',
      targetUrl: 'https://f1tv.formula1.com/page/1246/chasing-the-dream',
    },
    {
      imageUrl: 'thumbnail-9.png',
      targetUrl: 'https://f1tv.formula1.com/page/4881/beyond-all-limits',
    },
    {
      imageUrl: 'thumbnail-10.png',
      targetUrl: 'https://f1tv.formula1.com/page/1555/greatest-races',
    },
  ];

  return images;
};

export const retentionImages = () => {
  const images = [
    {
      image: `${insideStory}`,
      targetUrl: 'https://f1tv.formula1.com/page/1724/inside-story',
    },
    {
      image: `${techTalk}`,
      targetUrl: 'https://f1tv.formula1.com/page/1299/tech-talk',
    },
    {
      image: `${vettel}`,
      targetUrl:
        'https://f1tv.formula1.com/detail/1000006901/vettel-more-than-a-champion',
    },
    {
      image: `${beyondAllLimits}`,
      targetUrl: 'https://f1tv.formula1.com/page/4881/beyond-all-limits',
    },
    {
      image: `${chasingTheDream}`,
      targetUrl: 'https://f1tv.formula1.com/page/1246/chasing-the-dream',
    },
    {
      image: `${analysis}`,
      targetUrl: 'https://f1tv.formula1.com/page/1789/jolyon-palmer-s-analysis',
    },
    {
      image: `${bestOnboards}`,
      targetUrl: 'https://f1tv.formula1.com/page/2220/best-onboards',
    },
  ];

  return images;
};
